import * as React from 'react';
import { _ } from "@src/services/i18n";
import { vars, mixin, css, classNames } from '@src/services/theme';
import { isReadOnly } from 'services/user';

// typing
interface Props {
	className?: string;
	collapsed?: boolean;
	onToggle?: Function;
	title?: string;
	toolbar?: any;
	footer?: any;
	children: any;
	innerBox?: boolean;
	growedBox?: boolean;
	blockedHeight?: boolean;
	nodata?: boolean;
}

interface State {
	collapsed: boolean;
}

// style
const style = css`
    border: 1px solid #cccccc;
	background-color: ${vars.colors.white};
	margin-bottom: 20px;

	> header {
        position: relative;
		display: flex;
		align-items: center;
        padding: 10px 30px;
        font-size: 18px;
        text-transform: uppercase;
        color: #666;
        background: #eeeeee;

		> * {
			&:not(:last-child) {
				padding-right: 1em;
			}
		}

		> span {
			cursor: pointer;
			position: absolute;
			padding: 0 !important;
			right: 10px;
            width: 30px;
            line-height: 30px;
            text-align: center;
			color: ${vars.colors.white};
            background: ${vars.colors.yellow};
            border-radius: 100%;
		}
    }
    > .content {
		> .padding {
        	padding: 20px;
		}
    }
	&.collapsable {
		> header {
			padding-right: 60px;
		}
		> .content {
			overflow: hidden;
			transition: all .5s;
			max-height: 100000px;
		}
		&.collapsed {
			> .content {
				max-height: 0;
			}
		}
	}

	/* special */
	/*.ReactTable {
		margin: -20px;

		> .rt-table {
			> .rt-tbody {
				> .rt-tr-group {
					> .rt-tr {
						> .rt-td {
							&:first-child {
								padding-left: 20px;
							}
							&:last-child {
								padding-right: 20px;
							}
						}
					}
				}
			}
		}
	}
	*/
`;

const styleNodata = css`
    color: ${vars.colors.grey};
    font-size: 3rem;
    text-align: center;
    padding: 4rem;
`;

// component
export default class Box extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			collapsed: this.props.collapsed,
		} as State;
	}

	_toggle = () => {
		const { collapsed } = this.props;
		if (typeof collapsed === 'undefined') { return; }
		this.setState({
			collapsed: !this.state.collapsed,
		});
		if (this.props.onToggle) this.props.onToggle(!this.state.collapsed);
	};

	render() {
		const { className, title, toolbar, footer, children, nodata } = this.props;
		const { collapsed } = this.state;
		const html = (html) => ({ __html: html });
		return (
			<div
				className={classNames(
					style,
					className,
					'box',
					collapsed ? 'collapsed' : null,
					typeof collapsed !== 'undefined' ? 'collapsable' : null
				)}
			>
				{title && (
					<header>
						{(typeof collapsed !== 'undefined') && (typeof children !== 'undefined') && (
							<span onClick={this._toggle}>
								<span
									className={collapsed ? 'fa fa-caret-down' : 'fa fa-caret-up'}
								/>
							</span>
						)}
						<div dangerouslySetInnerHTML={html(title)} />
						{toolbar &&(
							toolbar()
						)}
					</header>
				)}
				{nodata && 
					<div className={styleNodata}>
						{ _('nodata') }
					</div>
				}
				{!nodata &&
				<>
					{(typeof children !== 'undefined') &&
					<div className="content"><div className="padding">{children}</div></div>
					}
					{footer && (
						footer()
					)}
				</>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/UI/Box.tsx